var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('issue-order',{ref:"orders",attrs:{"type":_vm.type},on:{"clearDetails":_vm.clearDetails,"issue":_vm.issue,"restore":_vm.restore,"showDetails":_vm.showDetails}}),_c('issue-detail',{ref:"details",attrs:{"type":_vm.type}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }